import React from 'react';
import styled from '@emotion/styled';
import { FONT_STYLE } from '@bucketplace/design-system';

export interface HeaderButtonProps {
  className?: string;
  isActive?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export function HeaderButton(props: HeaderButtonProps): React.ReactElement {
  const { className, isActive, onClick, children } = props;
  return (
    <StyledHeaderButton
      type="button"
      className={className}
      onClick={onClick}
      aria-pressed={isActive}
      isActive={isActive}
    >
      { children }
    </StyledHeaderButton>
  );
}

const StyledHeaderButton = styled.button<{ isActive?: boolean }>`
  height: 100%;
  ${FONT_STYLE.detail12L16};
  color: ${({ theme }) => theme.base.neutral0};
  padding: 3px 6px 4px;
  margin: -4px 0 -5px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.base.neutral500};
  }

  ${({ isActive, theme }) => isActive && `
    background-color: ${theme.base.neutral500};
  `}
`;
